import Homecontent from "./data/homecontent";
import { Topheader } from "./common/topheader";
import astro from "./images/services/health.jpg";
import { Innerbanner } from "./common/innerbanner";
import {Footer} from './common/footer';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhoneSquare } from "@fortawesome/free-solid-svg-icons";
function  Health(props2){


    return(
<div>
<Topheader></Topheader>
<Innerbanner title={"Medical Astrolgy Guidance "}></Innerbanner>

<div className="container-fluid">

    <div className="container">
<div className="d-flex flex-column flex-sm-row flex-lg-row flex-md-row">

    <div className="bg-light shadow p-3 m-3 flex-fill"><img  src={astro } alt="famous astrologer Gurgaon" className="img-fluid float-start m-3"></img>
   <p> 
   Health
   Astrology can offer significant insights and guidance related to health and wellness by analyzing certain houses and planetary influences in your birth chart. Here's how an astrologer like Sanjay Bhargav can assist you:
   </p>  
<p>
<span className="fw-bolder">Health Predictions </span> By examining the planetary positions and their influences on the aforementioned houses, astrologers can predict possible health issues and provide guidance on preventive measures.</p><p>
<span className="fw-bolder">Timing of Health Issues:</span>Astrologers can identify periods when you might be more susceptible to health problems by studying planetary transits and Dasha periods, enabling you to take extra precautions during those times.</p>
<p>
<span className="fw-bolder">Personalized Wellness Plans:</span> Based on the analysis, astrologers can recommend specific lifestyle changes, diets, and routines that are in harmony with your astrological chart to improve overall well-being.</p><p>
<span className="fw-bolder">Astrological Remedies</span> To mitigate negative influences of planets, astrologers can suggest remedies such as wearing specific gemstones, chanting mantras, or performing certain rituals aimed at enhancing health and vitality.</p>


<p>Regularly consulting with an astrologer can provide ongoing support and guidance to maintain your health.<br/><br/>

Astrology should be seen as a complementary tool rather than a substitute for professional medical advice. Always consult healthcare professionals for medical concerns.</p>
<p className="text-center"><h6>Curious about how to apply these insights to your personal health journey?</h6><a href='https://api.whatsapp.com/send?phone=919873336259&text='><button className="btn btn-danger">I'm here to assist!</button></a></p>
    </div>


</div>


    </div>



</div>
<Footer></Footer>









</div>






 );







    
}
export {Health} ;